import { FC, useCallback, useState } from 'react';
import { App, Button, Dropdown, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { SendOutlined } from '@ant-design/icons';
import { useUIDispatchContext } from 'providers/UI';
import { sendDoctorEmail } from 'services/api/users';

import { useDoctorProfile } from 'pages/DoctorProfile/DoctorProfileContext';
import { showErrorMessage } from 'utils/showErrorMessage';

interface IProps {
  id: string;
  lang: string;
  allowToEdit?: boolean;
}

const Send: FC<IProps> = ({ id, allowToEdit }) => {
  const { t } = useTranslation();
  const { modal } = App.useApp();

  const { toggleModal } = useUIDispatchContext();
  const { profile } = useDoctorProfile();

  const [isSending, setIsSending] = useState(false);

  const onSendEmailDoctor = useCallback(() => {
    modal.confirm({
      title: t('common.confirm'),
      content: t('common.sure'),
      async onOk() {
        if (!profile?.email) return;

        try {
          setIsSending(true);
          await sendDoctorEmail(profile.email);
          message.success(t('messages.successfully_sending'));
        } catch (err) {
          showErrorMessage(err);
        } finally {
          setIsSending(false);
        }
      }
    });
  }, [modal, t, profile?.email]);

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'send_email',
            label: 'Send Email',
            onClick: onSendEmailDoctor
          },
          {
            key: 'send_notification',
            label: 'Send Notification',
            onClick: () => toggleModal('sendNotification', true, { id })
          }
        ]
      }}
      disabled={!allowToEdit}
    >
      <Button
        size="large"
        type="primary"
        loading={isSending}
        icon={<SendOutlined />}
        style={{ width: 140 }}
        disabled={!allowToEdit}
      >
        Send
      </Button>
    </Dropdown>
  );
};

export default Send;
